import { Modal } from "./modal";

const DepositShift = { Modal };

export default DepositShift;
